// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SoftUpdate__container-a72dd1 {
  border-radius: 0 !important;
  height: 48px;
  width: 100%;
  flex: 0 0 auto;
  position: relative;
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/SoftUpdate/styles.m.css"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AACF","sourcesContent":[".container {\n  border-radius: 0 !important;\n  height: 48px;\n  width: 100%;\n  flex: 0 0 auto;\n  position: relative;\n  z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SoftUpdate__container-a72dd1`
};
module.exports = ___CSS_LOADER_EXPORT___;
